"use strict";
/**
 * Created on 10 01 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");
/**
 * <p>Data dictionary validator related to {@link NumberRange}.</p>
 *
 * @author JMe
 */


var NumberRangeValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(NumberRangeValidator, _Validator_1$Validato);

  /**
   * Ctor.
   *
   * @param minAllowed Minimum value of range allowed. If null, there is no limit at this end.
   * @param maxAllowed Maximum value of range allowed. If null, there is no limit at this end.
   * @param keysDesc Description of translation keys.
   */
  function NumberRangeValidator(minAllowed, maxAllowed, keysDesc) {
    var _this;

    _classCallCheck(this, NumberRangeValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumberRangeValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
    _this.minAllowed = minAllowed;
    _this.maxAllowed = maxAllowed;
    _this.keysDesc = keysDesc;
    return _this;
  }

  _createClass(NumberRangeValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      //minimum value lower than minimum allowed
      if (this.minAllowed !== null && value.minimum !== null && value.minimum < this.minAllowed) {
        if (this.minAllowed === 0) {
          var msgKeySpec = this.keysDesc ? this.keysDesc.minNotPositiveNumberKey : NumberRangeValidator.DEFAULT_KEYS_DESC.minNotPositiveNumberKey;
          return new ValidationResult_1.ValidationError(msgKeySpec, value.minimum);
        }

        var msgKey = this.keysDesc ? this.keysDesc.minLowerThanAllowed : NumberRangeValidator.DEFAULT_KEYS_DESC.minLowerThanAllowed;
        return new ValidationResult_1.ValidationError(msgKey, [value.minimum, this.minAllowed]);
      } // maximum value is higher than maximum allowed


      if (this.maxAllowed !== null && value.maximum !== null && value.maximum > this.maxAllowed) {
        var _msgKey = this.keysDesc ? this.keysDesc.maxHigherThanAllowed : NumberRangeValidator.DEFAULT_KEYS_DESC.maxHigherThanAllowed;

        return new ValidationResult_1.ValidationError(_msgKey, [value.maximum, this.maxAllowed]);
      } // minimum value is higher than maximum value alias invalid range provided


      if (value.minimum !== null && value.maximum !== null && value.minimum > value.maximum) {
        var _msgKey2 = this.keysDesc ? this.keysDesc.maxLowerThanMin : NumberRangeValidator.DEFAULT_KEYS_DESC.maxLowerThanMin;

        return new ValidationResult_1.ValidationError(_msgKey2, [value.minimum, value.maximum]);
      } // maximum value lower than minimum allowed


      if (this.minAllowed !== null && value.maximum !== null && value.maximum < this.minAllowed) {
        if (this.minAllowed === 0) {
          var _msgKeySpec = this.keysDesc ? this.keysDesc.maxNotPositiveNumberKey : NumberRangeValidator.DEFAULT_KEYS_DESC.maxNotPositiveNumberKey;

          return new ValidationResult_1.ValidationError(_msgKeySpec, value.maximum);
        }

        var _msgKey3 = this.keysDesc ? this.keysDesc.maxLowerThanMinimumAllowed : NumberRangeValidator.DEFAULT_KEYS_DESC.maxLowerThanMinimumAllowed;

        return new ValidationResult_1.ValidationError(_msgKey3, [value.maximum, this.minAllowed]);
      } // minimum value higher than maximum allowed


      if (this.maxAllowed !== null && value.minimum !== null && value.minimum > this.maxAllowed) {
        var _msgKey4 = this.keysDesc ? this.keysDesc.minHigherThanMaximumAllowed : NumberRangeValidator.DEFAULT_KEYS_DESC.minHigherThanMaximumAllowed;

        return new ValidationResult_1.ValidationError(_msgKey4, [value.minimum, this.maxAllowed]);
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return NumberRangeValidator;
}(Validator_1.Validator);

exports.NumberRangeValidator = NumberRangeValidator;
NumberRangeValidator.DEFAULT_KEYS_DESC = {
  minNotPositiveNumberKey: 'value__must_be_positive_number',
  maxNotPositiveNumberKey: 'value__must_be_positive_number',
  minLowerThanAllowed: 'range__minimum_lower_than_allowed',
  maxHigherThanAllowed: 'range__maximum_higher_than_allowed',
  maxLowerThanMin: 'range__maximum_lower_than_minimum',
  minHigherThanMaximumAllowed: 'range__minimum_higher_than_maximum_allowed',
  maxLowerThanMinimumAllowed: 'range__maximum_lower_than_minimum_allowed'
};
NumberRangeValidator.DEFAULT_FROM_TO_KEYS_DESC = {
  minNotPositiveNumberKey: 'value__must_be_positive_number',
  maxNotPositiveNumberKey: 'value__must_be_positive_number',
  minLowerThanAllowed: 'range__from_lower_than_allowed',
  maxHigherThanAllowed: 'range__to_higher_than_allowed',
  maxLowerThanMin: 'range__to_lower_than_from',
  minHigherThanMaximumAllowed: 'range__from_higher_than_to_allowed',
  maxLowerThanMinimumAllowed: 'range__to_lower_than_from_allowed'
};